var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appContent"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta.keepAlive && _vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('audio',{ref:"examAudio",attrs:{"src":_vm.audioSrc},on:{"error":_vm.audioError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }